import React from "react";
import "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faReact,
  faDocker,
  faPython,
} from "@fortawesome/free-brands-svg-icons";
import Chip from "@mui/material/Chip";
import "../assets/styles/Expertise.scss";

const labelsFirst = [
  "Spring Boot",
  "Node.js",
  "React.js",
  "MySQL",
  "MongoDB",
  "Docker",
  "Kafka",
  "Python",
  "Grafana",
];

const labelsSecond = [
  "AWS",
  "Azure",
  "Git",
  "GitHub Actions",
  "Jest",
  "Cypress",
  "Mockito",
  "JUnit",
  "Rest Assured",
];

const labelsThird = [
  "Data Structures",
  "Algorithms",
  "LeetCode",
  "Problem Solving",
  "Agile Methodologies",
  "Scrum",
  "UI/UX Design",
];

function Expertise() {
  return (
    <div className="container" id="expertise">
      <div className="skills-container">
        <h1>Professional Summary</h1>
        <div>
          <h3>
            Samuel Maina is a results-driven Software Engineer with 3.5+ years
            of experience building scalable, high-performance applications in
            finance, IoT, Machine Learning, and blockchain. Expertise in Spring
            Boot, Node.js, React.js and cloud technologies (AWS, Azure, Docker)
            with a strong background in microservices, distributed systems, and
            real-time data processing.
          </h3>
          <h3>
            Passionate about clean architecture and following good software
            principles such as automated testing and solving complex problems
            using simple solutions. Committed to delivering secure, user-centric
            solutions that drive business growth.
          </h3>
          <div className="flex-chips">
            <span className="chip-title">Tech stack:</span>
            {labelsFirst.map((label, index) => (
              <Chip key={index} className="chip" label={label} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Expertise;
